export interface Appearance {
  theme?: string;
  fontSize?: string;
}
